/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { SocialIconProps } from '../../types';
import { BadgeContainer } from './badgeContainer';

export const YouTubeIcon = memo(({ 
    width = 40, 
    height = 40,
    fillColor = '#2F6F8C'
}: SocialIconProps) => {
    return (
        <BadgeContainer>
            <svg width={width} height={height} viewBox='0 0 48 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path 
                    d='M46.9964 5.28C46.4455 3.20182 44.8173 1.56546 42.7527 1.00909C39.0109 1.9507e-07 24 0 24 0C24 0 8.98909 1.9507e-07 5.24727 1.00909C3.18273 1.56546 1.55455 3.20182 1.00364 5.28C6.50233e-08 9.04909 0 16.9091 0 16.9091C0 16.9091 6.50233e-08 24.7691 1.00364 28.5382C1.55455 30.6164 3.18273 32.2527 5.24727 32.8091C8.98909 33.8182 24 33.8182 24 33.8182C24 33.8182 39.0109 33.8182 42.7527 32.8091C44.8173 32.2527 46.4455 30.6164 46.9964 28.5382C48 24.7691 48 16.9091 48 16.9091C48 16.9091 48 9.04909 46.9964 5.28ZM19.0909 24.0464V9.77182L31.6364 16.9091L19.0909 24.0464Z' 
                    fill={fillColor} />
            </svg>
        </BadgeContainer>
    );
});
